import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { useShortSelector } from 'react-redux-app/lib/modules/core/hooks';
import { useCurrentLang } from 'react-redux-app/lib/modules/i18n/hooks';

import { l } from 'react-redux-app/lib/modules/i18n/utils';
import { getHost, getRivcashForumUrl } from '../../utils/siteUrls';

import { LANG_EN } from '../../../core/lang/constants';
import { SITE_ID__ONLYFEETCASH, forumSiteIds } from '../../constants/rivcashClones';

import { getRivcashCloneId } from '../../../init/selectors/initData';

import { actionShowContactUsDialog } from '../../../contactUs/actions/dialogs/contactUsDialog';

import { ActionLink } from 'react-redux-app/lib/modules/actionLink/components';
import { Link } from 'react-redux-app/lib/modules/link/components';

import styles from './styles/index.css.json';


const getBasePartUrl = lang => `${getHost()}${lang}/webmaster`;

export default () => {
  const dispatch = useDispatch();

  const siteId = useShortSelector(getRivcashCloneId);
  const lang = useCurrentLang();

  const linkGroups = useMemo(() => {
    const linksGroups = [
      [
        {
          key: 'index.php',
          to: `${getBasePartUrl(lang)}/index.php`,
          text: l('footer-links.adult-webcam-affiliate'),
        },
        {
          key: 'affiliate-program.php',
          to: `${getBasePartUrl(lang)}/${lang === LANG_EN ? 'affiliate-program.php' : 'programmi-di-affiliazione.php'}`,
          text: l('footer-links.affiliate-programs'),
        },
        {
          key: 'tools.php',
          to: `${getBasePartUrl(lang)}/${lang === LANG_EN ? 'tools.php' : 'programmi-affiliazione-adulti.php'}`,
          text: l('footer-links.promotional-tools'),
        },
        {
          key: 'sites.php',
          to: `${getBasePartUrl(lang)}/${siteId === SITE_ID__ONLYFEETCASH
            ? 'foot-fetish-affiliate.php'
            : ((lang === LANG_EN && 'sites.php') || 'affiliazione-ragazze-in-vendita.php')}`,
          text: l('footer-links.sites'),
        },
        {
          key: 'white-label-website.php',
          to: `${getBasePartUrl(lang)}/${lang === LANG_EN ? 'white-label-website.php' : 'sito-white-label.php'}`,
          text: l('footer-links.white-label-website'),
        },
      ],
      [
        {
          key: 'about_us.php',
          to: `${getBasePartUrl(lang)}/about_us.php`,
          text: l('footer-links.about-us'),
        },
        {
          key: 'media.php',
          to: `${getBasePartUrl(lang)}/media.php`,
          text: l('footer-links.media'),
        },
        {
          key: 'news.php',
          to: `${getBasePartUrl(lang)}/news.php`,
          text: l('footer-links.news'),
        },
        {
          key: 'faq.php',
          to: `${getBasePartUrl(lang)}/faq.php`,
          text: l('footer-links.faq'),
        },
        {
          key: 'contactUs',
          onClick: () => { dispatch(actionShowContactUsDialog()); },
          text: l('footer-links.contact-us'),
        },
      ],
      [
        {
          key: 'affagreement.php',
          to: `${getBasePartUrl(lang)}/affagreement.php`,
          text: l('footer-links.affiliate-agreement'),
        },
        {
          key: 'terms.php',
          to: `${getBasePartUrl(lang)}/terms.php`,
          text: l('footer-links.terms-and-conditions'),
        },
        {
          key: 'spampolicy.php',
          to: `${getBasePartUrl(lang)}/spampolicy.php`,
          text: l('footer-links.spam-policy'),
        },
        {
          key: 'privacy.php',
          to: `${getBasePartUrl(lang)}/privacy.php`,
          text: l('footer-links.privacy-policy'),
        },
        {
          key: '182257rkrcs.php',
          to: `${getBasePartUrl(lang)}/182257rkrcs.php`,
          text: l('footer-links.records-keeping-requirements-compliance'),
        },
      ],
    ];
    if (forumSiteIds.includes(siteId)) {
      linksGroups.push([{
        key: 'forum',
        to: getRivcashForumUrl(lang),
        text: l('footer-links.forum'),
      }]);
    }
    return linksGroups;
  }, [lang]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={styles.footer}>
      <div className={styles.footer__links}>
        {linkGroups.map((group, i) => (
          <div
            /* eslint-disable react/no-array-index-key */
            key={`group_${i}`}
            className={styles.footer__linksGroup}
          >
            {group.map(({
              onClick,
              key,
              to,
              text,
            }) => (to ? (
              <Link key={key} to={to} isExternal className={styles.footer__link}>
                {text}
              </Link>
            ) : (
              <ActionLink key={key} onClick={onClick} className={styles.footer__link}>
                {text}
              </ActionLink>
            )))}
          </div>
        ))}
      </div>
      <div className={styles.footer__copyright}>
        {l('msg.copyright')}
      </div>
    </div>
  );
};
